import { createSelector } from 'reselect';

const getNavigationData = state => state.metaGameReducer.navigation;

// eslint-disable-next-line import/prefer-default-export
export const getCurrentScreen = createSelector(
  [getNavigationData],
  navigation => navigation.screen,
);
